import classNames from "classnames";
import { forwardRef } from "react";

import { ignoreAttribute } from "@ascendnow/shared";

import AscButton from "../../AscButton/AscButton";
import AscImage from "../../AscImage/AscImage";
import styles from "./AscTrueOrFalseQuestionItem.module.scss";

export interface AscTrueOrFalseQuestionItemProps {
  id: string;
  question: string;
  coverImageUrl?: string;
  onAnswerChange: (id: string, answer: boolean) => void;
  answerLoading?: boolean;
  loading?: boolean;
  className?: string;
  disabled?: boolean;
  answer?: boolean;
}

const AscTrueOrFalseQuestionItem = forwardRef<
  HTMLDivElement,
  AscTrueOrFalseQuestionItemProps
>(
  (
    {
      id,
      question,
      coverImageUrl,
      onAnswerChange,
      answerLoading = false,
      loading = false,
      className,
      disabled,
      answer,
    },
    ref
  ) => {
    function handleFalseAnswer() {
      onAnswerChange(id, false);
    }
    function handleTrueAnswer() {
      onAnswerChange(id, true);
    }
    return (
      <div
        ref={ref}
        className={classNames(
          styles.ground,
          {
            [styles.loading]: loading,
          },
          className
        )}
      >
        <div className={styles.question}>{question}</div>
        {coverImageUrl ? (
          <div className={styles.imageWrapper}>
            <AscImage className={styles.image} src={coverImageUrl} />
          </div>
        ) : null}
        <div className={styles.answerButtons}>
          <AscButton
            variant={answer === true ? "PURPLE" : "outlined"}
            loading={answer === true && answerLoading}
            onClick={handleTrueAnswer}
            disabled={disabled}
            className={styles.answerButton}
            {...ignoreAttribute.contrast}
          >
            True
          </AscButton>
          <AscButton
            variant={answer === false ? "PURPLE" : "outlined"}
            loading={answer === false && answerLoading}
            onClick={handleFalseAnswer}
            disabled={disabled}
            className={styles.answerButton}
            {...ignoreAttribute.contrast}
          >
            False
          </AscButton>
        </div>
      </div>
    );
  }
);

export default AscTrueOrFalseQuestionItem;
